import React, { Component } from "react";
import DataTable from "react-data-table-component";
//// componentes reutilizables
import CuentaSocioTransferencia from "../../../generico/CuentaSocioTransferencia";
import $ from "jquery";
import TransferCuentasPropiasService from "../../../../services/transferencias/TransferCuentasPropiasService";
import PopupAgregarCuenta from "./PopupAgregarCuenta";
import Popup from "react-popup";
import { trackPromise } from "react-promise-tracker";
import AuthService from "../../../../services/login/auth.service";
import TransferInterentidadService from "../../../../services/transferencias/TransferInterentidadService";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faMagnifyingGlass, faFilter, faEraser, faBan, faTrashCan, faPlus, faSearch, faArrowRight} from "@fortawesome/free-solid-svg-icons";
import history from "../../login/history";
import ConfigService from "../../../../services/configuracion/ConfigService";
import TransferenciasService from "../../../../services/transferencias/TransferenciasService";
import PopupAgregarAlias from "./PopupAgregarAlias";

const paginationOptions = {
  rangeSeparatorText: "de",
  noRowsPerPage: true,
};

export default class TransferenciaInterentidad extends Component {
  
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.deleteCuentaExterna = this.deleteCuentaExterna.bind(this);
    this.lovFilter1 = React.createRef();
    this.lovFilter2 = React.createRef();
    this.lovFilter3 = React.createRef();
    this.lovFilter4 = React.createRef();
    this.lovFilter5 = React.createRef();
  }
  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

    mensajeLimiteTransferencias = (titulo, mensaje) =>
      Popup.register({
        title: titulo,
        content: mensaje,
        buttons: {
          right: [
            {
              text: "Cancelar",
              className: "secundary",
              action: () =>{
                history.push(ConfigService.getPathByName("resumenGeneralSocio")?.url);
                window.location.reload();
                Popup.close();
              }
            },
            {
              text: "Continuar",
              className: "success",
              action: () =>{
                this.setState({continuar:true},()=>{
                  this.continuarSigtePaso();
                });
                Popup.close();
              }
            }
          ]
        }
      });

  componentDidMount() {
    this.initData();
    this.initFilters();
    this.verificaTienePin();
    this.verificarLimiteTransferencias();
  }

  initFilters() {
    this.filter1.style.display = "";
    this.filter2.style.display = "none";
    this.filter3.style.display = "none";
    this.filter4.style.display = "none";
    this.filter5.style.display = "none";
  }
  initData = () => {
    this.resetState();
    this.getCuentasExternas();
    this.getCuentas();
    this.getEntidades();
    this.getTiposDocumentos();
    this.getTiposAlias();
    this.continuar.disabled = true;
    this.entidadSelected = undefined;
  };
  resetState = () => {
    this.setState(this.getInitialState());
  };

  getInitialState = () => ({
    cuentasExternas: [],
    cuentasExternasFiltrado: [],
    cuentasOrigen: "",
    monto: 0,
    itemSelected: { value: "-1", label: "--Seleccione--" },
    entidades: [],
    tipoEntidadList: [],
    nroCuentaNew: "",
    nombreApellidoNew: "",
    tipoDocNew: "",
    documentoNew: "",
    tiposDocumentos: [],
    tiposAlias: [],
    disableSgte: true,
    cuentaOrigenSelected: [],
    mensaje: undefined,
    msgAdverLimTrans:false,
    continuar:false,
    comisionTransferencia:0,
    aliasEnvado:null
  });

  getEntidades() {
    trackPromise(
      TransferInterentidadService.getEntidades().then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
        if (jData.codigo === 0) {

          let tipoEntidadList = [];

          jData.datos.forEach((element, index) => {

            let exists = false;

            if (index === 0) {
              tipoEntidadList.push(element.nombreTipoEntidad);
            } else {
              exists = tipoEntidadList.some(tipoEntidad => tipoEntidad === element.nombreTipoEntidad);
              if (!exists) {
                tipoEntidadList.push(element.nombreTipoEntidad);
              }
            }
          });

          this.setState({ entidades: jData.datos, tipoEntidadList });
        }
      })
    ).catch(function (error) {
      console.log(error);
    });
  }

  verificarLimiteTransferencias(){
    trackPromise(
      TransferenciasService.consultaCantidadTransferencias()
      .then( (resp)=>{
        if( resp.status !== 200 ){
          Popup.queue(this.notifiPopup("Error", "Ocurrió un error Inesperado al consultar cantidad de transferencias hechas. Por favor vuelva a intentar más tarde."));
          return;
        }
        if( resp.data.codigo !== 0 ){
          Popup.queue(this.notifiPopup("Error", resp.data.mensaje));
          return;
        }
        if( resp.data.datos.cobrar ){
          let mensaje = 'Ha alcanzado la cantidad máxima (7) de transferencias gratuitas permitidas.\nA partir de esta operación tendrá un costo de Gs.'+resp.data.datos.comision+'. ¿Está seguro de realizarlo?';
          this.setState({msgAdverLimTrans:true , comisionTransferencia : resp.data.datos.comision});
          
        }
      })
      .catch( err=>{
        console.log(err);
      })
    )
  }

  getCuentasExternas() {
    trackPromise(
      TransferInterentidadService.getCuentasExternas().then((response) => {
        var respuesta = [];
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
        if (jData.codigo === 0) {
          var items = jData.datos;

          for (var i = 0; i < items.length; i++) {
            respuesta.push({
              id: items[i].id,
              titular: items[i].nombreDestino,
              entidad: items[i].entidadDestino.nombre,
              nroCuenta: items[i].cuentaDestino,
              codEntidad: items[i].entidadDestino.id,
              tipoDocDestino: items[i].tipoDocumentoDestino.descripcion,
              docDestino: items[i].numeroDocumentoDestino,
              destinatario: items[i].destinatario,
              intermediario: items[i].entidadDestino.intermediario,
              entidadDatosAlternativos: items[i].entidadDestino.entidadDatosAlternativos,
              alias: items[i].alias,
              tipoAlias: items[i].tipoAlias
            });
          }
        }
        this.setState({ cuentasExternas: respuesta });
        this.setState({ cuentasExternasFiltrado: respuesta });
      })
    ).catch(function (error) {
      console.log(error);
    });

    return this.state.cuentasExternas;
  }

  getTiposDocumentos() {
    trackPromise(
      TransferInterentidadService.getTiposDocumentos().then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
        if (jData.codigo === 0) {
          this.setState({ tiposDocumentos: jData.datos });
        }
      })
    ).catch(function (error) {
      console.log(error);
    });
  }
  getTiposAlias() {
    trackPromise(
      TransferInterentidadService.getTiposAlias().then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
      
        if (jData.codigoRetorno === '0') {
          const datosFiltrados = jData.datos.filter(item => item !== "CRC" && item !== "CRP");
          this.setState({ tiposAlias: datosFiltrados });
        }
      })
    ).catch(function (error) {
      console.log(error);
    });
  }
  deleteCuentaExterna = (value) => {
    trackPromise(
      TransferInterentidadService.deleteCuentaExterna(value).then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);

        if (jData.codigo === 0) {
          Popup.close();
          this.getCuentasExternas();
        } else {
          Popup.close();
          Popup.queue(this.notifiPopup("Info", jData.mensaje));
        }
      })
    ).catch(function (error) {
      console.log(error);
    });
  };

  getColumn() {
    return [
      {
        cell: (row) => (
          <div>
            <input
              ref={() => this.entidadSelected}
              id={"radio_" + row.id}
              type="radio"
              key={row.id}
              name="rowRadio"
              value={row.id}
              onClick={this.handleSelectRadioBtn}
            ></input>
            
          </div>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
      { id: 'id',
        name: "Id",
        selector: "id",
        omit: 'id',
      },
      {
        name: "Titular",
        selector: row => row.titular,
        sortable: true,
      },
      {
        name: "Entidad",
        selector: row => row.entidad,
        sortable: true,
        width: "200px"
      },
      {
        name: "Nro. de Cuenta",
        selector: row => row.nroCuenta,
        sortable: true,
      },
      {
        name: "Tipo de Documento",
        selector: row => row.tipoDocDestino,
        sortable: true,
      }, {
        name: "Nro. de Documento",
        selector: row => row.docDestino,
        sortable: true,
      }, {
        name: "Alias",
        selector: row => row.alias,
        sortable: true,
      },
      {
        name: "Tipo Alias",
        selector: row => row.tipoAlias,
        sortable: true,
      },
      {
        cell: (row) => (
          <div>
            <button
              id={row.id}
              className="btn btn-tool"
              style={{ paddingLeft: 15 }}
              value={row.id}
              onClick={(e) => {
                var deleteThisItem = e.currentTarget.value;
                Popup.create({
                  title: "Confirmación",
                  content: "¿Está seguro que desea eliminar la cuenta",
                  buttons: {
                    right: [
                      {
                        text: "Cancelar",
                        className: "secundary",
                        action: function () {
                          Popup.close();
                        },
                      },
                      {
                        text: "Aceptar",
                        className: "success",
                        action: () => {
                          this.deleteCuentaExterna(deleteThisItem);
                          Popup.close();
                        },
                      },
                    ],
                  },
                });
              }}
            >
              <FontAwesomeIcon className="item-trash" icon={faTrashCan} value={row.id} style={{ paddingBottom: 9 }} >{" "}</FontAwesomeIcon> 
            </button>
          </div>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,

      },
    ];
  }

  getDatosCuentaDestino(array, id) {
    var foundItems = $.grep(array, function (v) {
      return v.id.toString() === id.toString();
    });
    return foundItems;
  }

  filter(array, titular, entidad, nroCuenta, tipoDoc, valueDoc) {
    var foundItems = $.grep(array, function (v) {
      var found = true;

      if (titular.trim().length > 0) {
        found = v.titular.toUpperCase().includes(titular.toUpperCase());
      }
      if (found && entidad.trim().length > 0) {
        found = v.entidad.toUpperCase().includes(entidad.toUpperCase());
      }
      if (found && nroCuenta.trim().length > 0) {
        found = v.nroCuenta.toUpperCase().includes(nroCuenta.toUpperCase());
      }
      if (found && tipoDoc.trim().length > 0) {
        found = v.tipoDocDestino.toUpperCase().includes(tipoDoc.toUpperCase());
      }
      if (found && valueDoc.trim().length > 0) {
        found = v.docDestino.toUpperCase().includes(valueDoc.toUpperCase());
      }
      return found;
    });
    return foundItems;
  }

  selectorValue = (dataFromChild, item) => {
    this.setState(
      {
        cuentaOrigenSelected: dataFromChild,
        cuentaDebito: dataFromChild.cuenta,
        detalleCuenta: dataFromChild.cuenta + " " + dataFromChild.denominacion,
        itemSelected: item,
      },
      this.enableNext
    );
  };

  enableNext() {
    const { itemSelected } = this.state;
    if (
      itemSelected.value !== undefined &&
      itemSelected.value !== "-1" &&
      this.entidadSelected !== undefined
    ) {
      this.continuar.disabled = false;
    } else {
      this.continuar.disabled = true;
    }

    this.checkCuentaDestino();
  }
  checkCuentaDestino() {
    if (this.entidadSelected !== undefined) {
      $("#" + this.entidadSelected.id).prop("checked", true);
    }
  }
  montoValue = (dataFromChild) => {
    this.setState({
      monto: dataFromChild,
    });
  };

  continuarSigtePaso(){
    const vAlias = this.state.cuentasExternas.find(item => item.id ===Number(this.entidadSelected.value));
    if(vAlias!=null){
      this.setState({aliasEnvado:vAlias.alias})
    }
    var cuentaDestino = this.getDatosCuentaDestino(
      this.state.cuentasExternas,
      this.entidadSelected.value,
      this.state.aliasEnvado
    );

    this.props.returnDataPaso1(
      this.state.cuentaOrigenSelected,
      cuentaDestino
    );
    if (this.props.currentStep === 1) {
      this.props.nextStep();
    }
  }

  getCuentas() {
    trackPromise(
      TransferCuentasPropiasService.getCuentas("I").then((response) => {
        if (response.data.codigo !== "0" && response.data.mensaje === "SIN RESULTADOS") {
          Popup.queue(this.notifiPopup("Info", "No posee saldo suficiente en la(s) cuenta(s) de débito para continuar"));
        }
        var data = JSON.stringify(response.data);
        var jsonData = JSON.parse(data);
        this.setState({ cuentasOrigen: jsonData.resultadoAH });
      })
    ).catch(function (error) {
      console.log(error);
    });
  }
  handleLimpiarBtn = (e) => {
    this.input1.value = "";
    this.input2.value = "";
    this.input3.value = "";
    this.input4.value = "";
    this.input5.value = "";
    this.lovFilter1.current.value = "";
    this.lovFilter2.current.value = "";
    this.lovFilter3.current.value = "";
    this.lovFilter4.current.value = "";
    this.lovFilter5.current.value = "";

    this.setState({ cuentasExternasFiltrado: this.state.cuentasExternas });
  };

  handleBuscarBtn = (e) => {
    var filterMap = new Map();
    filterMap.set(this.lovFilter1.current.value, this.input1.value);
    filterMap.set(this.lovFilter2.current.value, this.input2.value);
    filterMap.set(this.lovFilter3.current.value, this.input3.value);
    filterMap.set(this.lovFilter4.current.value, this.input4.value);
    filterMap.set(this.lovFilter5.current.value, this.input5.value);

    var titularFilter =
      filterMap.get("titular") === undefined ? "" : filterMap.get("titular");
    var entidadFilter =
      filterMap.get("entidad") === undefined ? "" : filterMap.get("entidad");
    var nroCuentaFilter =
      filterMap.get("nroCuenta") === undefined
        ? ""
        : filterMap.get("nroCuenta");
    var tipoDocFilter =
      filterMap.get("tipoDoc") === undefined ? "" : filterMap.get("tipoDoc");
    var valueDocFilter =
      filterMap.get("valueDoc") === undefined ? "" : filterMap.get("valueDoc");

    var filtrado = this.filter(
      this.state.cuentasExternas,
      titularFilter,
      entidadFilter,
      nroCuentaFilter,
      tipoDocFilter,
      valueDocFilter
    );
    this.setState({ cuentasExternasFiltrado: filtrado });
  };

  handleSelectRadioBtn = (e) => {
    this.entidadSelected = e.currentTarget;
    this.enableNext();
  };
  addCuentaCallback = (data) => {
    if (data === "OK") {
      this.getCuentasExternas();
    }
  };

  campoFiltro(_refFilter, _refInput, _lovFilter) {
    return (
      <div className="row">
        <div className="col-lg-6 col-md-6 col-12">
          <select
            ref={_lovFilter}
            defaultValue=""
            name="select"
            className="form-control input-box btn-consulta"
          >
            <option key="-1" value="" disabled>
              -- Seleccione--
            </option>
            <option value="titular">Titular</option>
            <option value="entidad">Entidad</option>
            <option value="nroCuenta">Nro. de Cuenta</option>
            <option value="tipoDoc">Tipo de Documento</option>
            <option value="valueDoc">Valor Documento</option>
          </select>
        </div>
        <div className="col-lg-6 col-md-6 col-12">
          <button 
           className="btn btn-cu-secundary btn-consulta"
            onClick={() => {
              _refFilter.style.display = "none";
              _lovFilter.current.value = "";
              _refInput.value = "";
              this.handleBuscarBtn();
            }}
          >
          <FontAwesomeIcon icon={faBan} />  Eliminar Filtro
          </button>
        </div>
      </div>
    );
  }

  seleccionarFila(row) {
    //pintarFilaSeleccionada("row-" + row.id)
    //// control de radiobutton
    var radio = document.getElementById("radio_" + row.id);
    radio.checked = true;
    radio.click(this.selGrupoEvt);
  }

  verificaTienePin() {
    AuthService.verificaTienePin().then((response) => {
      var data = JSON.stringify(response.data);
      var jData = JSON.parse(data);

      if (jData.codigo !== 0) {
        this.setState(
          {
            mensaje: jData.mensaje,
          },
          function () {
            this.mainDiv.style.display = "none";
          }
        );
      } else {
      }
    });
  }
  irTransferenciaEntreSocios = (e) => {
    this.setState({ showPopup: false }, () => {
      this.props.history.replace('/transferencia/cuenta-tercero'); // redirige sin recargar
    });
  }


  render() {
    return (
      <div>
        <PopupAgregarAlias
          addCuentaCallback={this.addCuentaCallback.bind(this)}
          items={this.state.entidades}
          tipos={this.state.tiposDocumentos}
          tiposAlias={this.state.tiposAlias}
          tipoEntidadList={this.state.tipoEntidadList}
        />
        <PopupAgregarCuenta
          addCuentaCallback={this.addCuentaCallback.bind(this)}
          items={this.state.entidades}
          tipos={this.state.tiposDocumentos}
          tipoEntidadList={this.state.tipoEntidadList}
        />
        <form id="idFormPaso1" onSubmit={(e) => e.preventDefault()}>
          <div>
            <div className="row">
              <div className="steps clearfix">
                <ul role="tablist">
                  <li role="tab" className="current">
                    <span>
                      <div className="title">
                        <span className="title_text current">
                          Selección de Cuentas
                        </span>
                      </div>
                    </span>
                  </li>
                  <li role="tab" className="disabled">
                    <span>
                      <div className="title">       
                        <span className="title_text">
                          Datos de Transferencia
                        </span>
                      </div>
                    </span>
                  </li>
                  <li role="tab" className="disabled">
                    <span>
                      <div className="title">       
                        <span className="title_text">
                          Código de Verificación
                        </span>
                      </div>
                    </span>
                  </li>
                  <li role="tab" className="disabled">
                    <span>
                      <div className="title">         
                        <span className="title_text">
                          Datos de Verificación
                        </span>
                      </div>
                    </span>
                  </li>
                  <li role="tab" className="disabled last">
                    <span>
                      <div className="title">
                        <span className="title_text">Confirmación</span>
                      </div>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            {this.state.mensaje !== undefined && (
              <div className="row">
                <div className="col-md-6">
                  <div className="callout callout-warning consideraciones">
                    <h5>Consideraciones</h5>
                    <p>{this.state.mensaje}</p>
                  </div>
                </div>
              </div>
            )}

            <div ref={(div) => (this.mainDiv = div)}>
              <div className="row">
                <div className="col-md-5">
                  <CuentaSocioTransferencia
                    selectorValue={this.selectorValue.bind(this)}
                    operacion="DEBITO"
                    tipoCuenta="AHORRO_VISTA"
                    items={this.state.cuentasOrigen}
                    itemSelected={this.state.itemSelected}
                  />
                </div>
              </div>
              <br />
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                  <div className="row">
                    <div className="col-lg-6 col-md-6">
                    <label className="input-label-bold">
                      Seleccione la Cuenta Destino (a acreditar) *
                    </label>
                    </div>
                    
                    <div className="col-lg-2 col-md-3">
                    <button
                      data-toggle="modal"
                      data-target="#modal-cuenta"
                      className="btn btn-cu-secundary btn-consulta">
                      <FontAwesomeIcon icon={faPlus} /> Agregar Cuenta
                    </button>
                    </div>
                    <div className="col-lg-2 col-md-3" style={ConfigService.ocultarAlias("alias")}>
                    <button
                      data-toggle="modal"
                      data-target="#modal-alias"
                      className="btn btn-cu-secundary btn-consulta">
                      <FontAwesomeIcon icon={faPlus} /> Agregar Alias
                    </button>
                    </div>
                    <div className="col-lg-2 col-md-3">
                    <button
                      className="btn btn-cu-quintary"
                      type="button"
                      data-toggle="collapse"
                      data-target="#collapseExample"
                      aria-expanded="false"
                      aria-controls="collapseExample"
                    >
                      <FontAwesomeIcon icon={faSearch} /> Búsqueda
                    </button>
                    </div>
                  </div>

                   
                  
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <div className="collapse" id="collapseExample">
                        <div className="card card-body">
                          <div className="row">
                            <div className="col-md-12">
                              <div
                                ref={(div) => (this.filter1 = div)}
                                className="row"
                              >
                                <div className="col-lg-4 col-md-12 col-12">
                                  <div className="form-group">
                                    <input
                                      ref={(input) => (this.input1 = input)}
                                      type="text"
                                      className="form-control input-box"
                                      placeholder="Buscar"
                                      onChange={(e) => { }}
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-8 col-md-12 col-12">
                                  {this.campoFiltro(
                                    this.filter1,
                                    this.input1,
                                    this.lovFilter1
                                  )}
                                </div>
                              </div>

                              <div
                                ref={(div) => (this.filter2 = div)}
                                className="row"
                              >
                                <div className="col-lg-4 col-md-12 col-12">
                                  <div className="form-group">
                                    <input
                                      ref={(input) => (this.input2 = input)}
                                      type="text"
                                      name="entidad"
                                      className="form-control input-box"
                                      placeholder="Buscar"
                                      onChange={(e) => { }}
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-8 col-md-12 col-12">
                                  {this.campoFiltro(
                                    this.filter2,
                                    this.input2,
                                    this.lovFilter2
                                  )}
                                </div>
                              </div>

                              <div
                                ref={(div) => (this.filter3 = div)}
                                className="row"
                              >
                                <div className="col-lg-4 col-md-12 col-12">
                                  <div className="form-group">
                                    <input
                                      ref={(input) => (this.input3 = input)}
                                      type="text"
                                      name="nroCuenta"
                                      className="form-control input-box"
                                      placeholder="Buscar"
                                      onChange={(e) => { }}
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-8 col-md-12 col-12">
                                  {this.campoFiltro(
                                    this.filter3,
                                    this.input3,
                                    this.lovFilter3
                                  )}
                                </div>
                              </div>

                              <div
                                ref={(div) => (this.filter4 = div)}
                                className="row"
                              >
                                <div className="col-lg-4 col-md-12 col-12">
                                  <div className="form-group">
                                    <input
                                      ref={(input) => (this.input4 = input)}
                                      type="text"
                                      name="tipoDoc"
                                      className="form-control input-box"
                                      placeholder="Buscar"
                                      onChange={(e) => { }}
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-8 col-md-12 col-12">
                                  {this.campoFiltro(
                                    this.filter4,
                                    this.input4,
                                    this.lovFilter4
                                  )}
                                </div>
                              </div>

                              <div
                                ref={(div) => (this.filter5 = div)}
                                className="row"
                              >
                                <div className="col-lg-4 col-md-12 col-12">
                                  <div className="form-group">
                                    <input
                                      ref={(input) => (this.input5 = input)}
                                      type="text"
                                      name="valueDoc"
                                      className="form-control input-box"
                                      placeholder="Buscar"
                                      onChange={(e) => { }}
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-8 col-md-12 col-12">
                                  {this.campoFiltro(
                                    this.filter5,
                                    this.input5,
                                    this.lovFilter5
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <hr />
                          <div className="row"> 
                          <div className="col-lg-4 col-md-4 col-12">
                          <button
                                className="btn btn-cu-primary btn-consulta"
                                onClick={() => {
                                  //console.log(this.filter1.style.display);
                                  //console.log(this.filter1);

                                  if (
                                    this.filter1 !== undefined &&
                                    this.filter1.style.display === "none"
                                  ) {
                                    this.filter1.style.display = "";
                                  } else if (
                                    this.filter2 !== undefined &&
                                    this.filter2.style.display === "none"
                                  ) {
                                    this.filter2.style.display = "";
                                  } else if (
                                    this.filter3 !== undefined &&
                                    this.filter3.style.display === "none"
                                  ) {
                                    this.filter3.style.display = "";
                                  } else if (
                                    this.filter4 !== undefined &&
                                    this.filter4.style.display === "none"
                                  ) {
                                    this.filter4.style.display = "";
                                  } else if (
                                    this.filter5 !== undefined &&
                                    this.filter5.style.display === "none"
                                  ) {
                                    this.filter5.style.display = "";
                                  }
                                }}
                              >
                              <FontAwesomeIcon icon={faFilter} />  Agregar Filtro
                              </button>
                          </div>
                          <div className="col-lg-4 col-md-4 col-12">
                          <button
                               type="submit"
                                className="btn btn-cu-secundary btn-consulta" onClick={this.handleLimpiarBtn}>
                              <FontAwesomeIcon icon={faEraser} />  Limpiar Filtro
                              </button>
                          </div>
                          <div className="col-lg-4 col-md-4 col-12">
                          <button type="submit" className="btn btn-cu-quintary" onClick={this.handleBuscarBtn}>
                              <FontAwesomeIcon icon={faMagnifyingGlass} />  Buscar
                              </button>
                          </div>
                          </div>          

                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <DataTable
                        noHeader={true}
                        pagination={true}
                        columns={this.getColumn()}
                        data={this.state.cuentasExternasFiltrado}
                        dense={true}
                        defaultSortFieldId="id"
                        defaultSortAsc={false}
                        paginationComponentOptions={paginationOptions}
                        noDataComponent="no hay registros para mostrar"
                        responsive={true}
                        striped={true}
                        onRowClicked={(e) => this.seleccionarFila(e)}
                        pointerOnHover
                      />
                    </div>
                  </div>
                </div>
              </div>
              <hr />

              <div className="row">
                <div className="col-md-10">
                    <label
                      className="input-label-bold-obligatorio">
                      (*) Campos Obligatorios
                      <br />
                    </label>

                </div>
                <div className="col-md-2">
                    <button
                      className="btn btn-cu-primary"
                      ref={(button) => (this.continuar = button)}
                      onClick={() => {
                        if( this.state.msgAdverLimTrans ){
                          Popup.queue(
                            this.mensajeLimiteTransferencias(
                              'Aviso',
                              'Ha alcanzado la cantidad máxima (7) de transferencias gratuitas permitidas.\nA partir de esta operación tendrá un costo de Gs.5.500. ¿Está seguro de realizarlo?'
                            )
                          );
                        }else{
                          this.continuarSigtePaso();
                        }

                      }}
                    >
                      Continuar <FontAwesomeIcon icon={faArrowRight} />
                    </button>
                </div>
              </div>

            </div>
          </div>
        </form>
      </div>
    );
  }
}